/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_Method_Bia_ScaleInputs */

const en_us2_body_assessment_reference_method_bia_scale = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ScaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedance scale`)
};

const pt_br2_body_assessment_reference_method_bia_scale = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ScaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balança de bioimpedância`)
};

const es_419_body_assessment_reference_method_bia_scale = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ScaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báscula de bioimpedancia`)
};

const pt_pt2_body_assessment_reference_method_bia_scale = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ScaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balança de bioimpedância`)
};

const fr_fr2_body_assessment_reference_method_bia_scale = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ScaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance impédancemètre`)
};

const de_de2_body_assessment_reference_method_bia_scale = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ScaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedanzwaage`)
};

const it_it2_body_assessment_reference_method_bia_scale = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ScaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilancia impedenziometrica`)
};

/**
* | output |
* | --- |
* | "Bioimpedance scale" |
*
* @param {Body_Assessment_Reference_Method_Bia_ScaleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_method_bia_scale = /** @type {((inputs?: Body_Assessment_Reference_Method_Bia_ScaleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_Method_Bia_ScaleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_method_bia_scale(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_method_bia_scale(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_method_bia_scale(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_method_bia_scale(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_method_bia_scale(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_method_bia_scale(inputs)
	return en_us2_body_assessment_reference_method_bia_scale(inputs)
});
export { body_assessment_reference_method_bia_scale as "body-assessment.reference_method.bia_scale" }